import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  FormControlLabel,
  Checkbox,
  Box
} from '@mui/material';

const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Delete Item',
  message = 'Are you sure you want to delete this item?',
  itemName = '',
  warning = null,
  allowForceDelete = false,
  loading = false
}) => {
  const [forceDelete, setForceDelete] = useState(false);

  const handleConfirm = () => {
    onConfirm(forceDelete);
    setForceDelete(false);
  };

  const handleClose = () => {
    setForceDelete(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: 'error.main' }}>
        {title}
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>
        
        {itemName && (
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 'bold' }}>
            Item: {itemName}
          </Typography>
        )}

        {warning && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
              Warning: {warning.title || 'Dependencies Found'}
            </Typography>
            <Typography variant="body2">
              {warning.message}
            </Typography>
            {warning.details && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                  {warning.details}
                </Typography>
              </Box>
            )}
          </Alert>
        )}

        {allowForceDelete && warning && (
          <FormControlLabel
            control={
              <Checkbox
                checked={forceDelete}
                onChange={(e) => setForceDelete(e.target.checked)}
                color="error"
              />
            }
            label={
              <Typography variant="body2" sx={{ color: 'error.main' }}>
                Force delete (ignore dependencies)
              </Typography>
            }
          />
        )}

        {!allowForceDelete && warning && (
          <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
            To delete this item, please first remove or update the dependencies, or contact your administrator.
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={loading || (warning && !forceDelete && allowForceDelete)}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;